import * as core from '../../../../../../../core'
import * as prebuilt from '../../../../../../prebuilt'
import * as space from '../space'

export const RESOURCE = {
  payload: {
    alias: 'space:organizations',
    appAlias: space.RESOURCE.payload.alias,
    description: 'Organizations page',
    display: {
      isMain: false,
      position: 1,
    },
    name: 'Organizations',
    page: { id: prebuilt.Page.Id.SpaceOrganizations },
  },
  type: core.quiver.Resource.Type.AppPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.AppPage>
